import { useMemo } from 'react'
import { useTranslation } from 'react-i18next'

import { Flex } from '@percent/lemonade'
import { PermissionsList } from '@percent/domain/iam'
import { useServices } from '@percent/admin-dashboard/containers/service/ServiceContext'
import {
  useAssignedDomains,
  useEffectiveRoles,
  usePermissionMutations
} from '@percent/admin-dashboard/app/accounts/hooks'
import type { GroupPermissionsProps } from './GroupPermissions.types'
import styles from './GroupPermissions.module.scss'

export function GroupPermissions({ groupId }: GroupPermissionsProps) {
  const { t } = useTranslation()
  const { iamService } = useServices()

  const { assignedDomains, isLoading, markChanged, refresh } = useAssignedDomains('groups', groupId)

  const { effectiveDomains, getGroupHref, refresh: refreshEffectiveRoles } = useEffectiveRoles('groups', groupId)

  const { assignRole, unassignRole } = usePermissionMutations(
    iamService.assignAccountRole,
    iamService.unassignAccountRole,
    refresh,
    () => {
      markChanged()
      refreshEffectiveRoles()
    }
  )

  const domains = useMemo(() => assignedDomains ?? [], [assignedDomains])

  return (
    <Flex direction="column" w="100%">
      <PermissionsList
        title={t('groupDetail.permissions.title')}
        assignedDomains={domains}
        effectiveDomains={effectiveDomains}
        getGroupHref={getGroupHref}
        isLoading={isLoading}
        headerClassName={styles.header}
        accordionClassName={styles.accordion}
        assignAccountRole={async (roleId, domainId) => assignRole({ memberId: groupId, role: roleId, domainId })}
        unassignAccountRole={async (roleId, domainId) => unassignRole({ memberId: groupId, role: roleId, domainId })}
      />
    </Flex>
  )
}
